import { createFileRoute, redirect } from '@tanstack/react-router';

import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/risk-management/')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'home' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/risk-management/library-health', replace: true });
    },
});
